import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { HasPermissionService } from 'src/app/services/common/has-permission.service';
import { ConstantService, UserRoles } from 'src/app/services/common/constant.service';
@Component({
  selector: 'super-admin-tenant-warning',
  standalone: false,
  templateUrl: './super-admin-tenant-warning.component.html',
  styleUrl: './super-admin-tenant-warning.component.scss'
})
export class SuperAdminTenantWarningComponent implements OnInit {

   @Input() mode: 'default' | 'new' = 'default';

  isSuperAdmin = false;
  shouldShow = false;
  displayTenantName: string | null = null;

  constructor(
    private permissions: HasPermissionService,
    private constantService: ConstantService
  ) {}

  ngOnInit(): void {
    this.isSuperAdmin = this.permissions.allowAccess([UserRoles.SuperAdmin]);

    // Defer to allow tenant data to be available
    setTimeout(() => this.updateState());
  }

  ngOnChanges(): void {
    this.updateState();
  }

  private updateState(): void {
    const defaultTenant = this.constantService.getDefaultTenant();
    const currentTenant = this.constantService.mspTenant?.organizationName;

    this.shouldShow = this.isSuperAdmin &&!!defaultTenant && !!currentTenant && defaultTenant !== currentTenant;

    this.displayTenantName = this.shouldShow ? (this.mode === 'default' ? defaultTenant : currentTenant): null;
  }
}